import firebase from '../config/firebase.config';

const database = firebase.firestore();

export const fetchUserNotifications = async (userId, callback) => {
  try {
    if (!userId) {
      throw new Error('User ID is required');
    }
    const snapshot = await database
      .collection('membersDatabase')
      .doc(userId)
      .collection('notifications')
      .get();
    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error('Error fetching user notifications:', error);
    throw error;
  } finally {
    if (callback) {
      callback();
    }
  }
};

export const markNotificationsAsRead = async (userId) => {
  try {
    const snapshot = await database
      .collection('membersDatabase')
      .doc(userId)
      .collection('notifications')
      .where('isRead', '==', false)
      .get();

    const batch = database.batch();
    snapshot.docs.forEach((doc) => {
      batch.update(doc.ref, {
        isRead: true,
      });
    });
    await batch.commit();
  } catch (error) {
    console.error('Error marking notifications as read:', error);
    return {
      success: false,
      error: error.message || 'Failed to mark notifications as read',
    };
  }
};
